<template>
  <v-row class="mx-0" no-gutters>
    <v-col cols="12">
      <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="businessModule.p">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn :color="mainColor"
                   fab
                   dark
                   depressed
                   small
                   @click="toggleAddPersonToBusinessComponent(!isAddPersonToBusinessComponentVisible)"
                   v-on="on">
              <v-icon>{{ isAddPersonToBusinessComponentVisible ? 'mdi-close' : 'mdi-plus' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ isAddPersonToBusinessComponentVisible ? $t('general.cancel') : $t('general.addPersonToBusiness', { business: businessModule.s }) }}</span>
        </v-tooltip>
      </ComponentsFixedBar>
    </v-col>

    <template v-if="isAddPersonToBusinessComponentVisible">
      <v-col cols="12"
             class="pb-4"
             style="padding-top: 50px">
        <AddPersonToBusiness :main-color="mainColor"
                             :user-id="selectedUser.userId"
                             :user-businesses="selectedUser.business"
                             @getUser="getUser()"
                             @toggleAddPersonToBusinessComponent="toggleAddPersonToBusinessComponent(false)" />
      </v-col>
    </template>

    <template v-else>
      <template v-if="selectedUser.business.length === 0">
        <v-col cols="12"
               style="padding-top: 50px">
          <div style="width: 100%; height: 30vh"
               class="d-flex flex-column align-center justify-center">
            <div class="pb-2 d-flex justify-center align-center">
              <v-icon :color="mainColor" size="45px" class="mr-2">feather-dollar-sign</v-icon>
            </div>
            <span class="kbGray--text text-center d-block"
                  style="font-size: 18px; max-width: 70%; margin: 0 auto">
            {{ $t('general.thisPersonHasNoBusinesses', { business: businessModule.p }) }}
          </span>
          </div>
        </v-col>
      </template>

      <template v-else>
        <BusinessesList :businesses="selectedUser.business"
                        :main-color="mainColor" />
      </template>
    </template>
  </v-row>
</template>

<script>
// import notifications from '@/libs/notifications'
import { mapState, mapGetters } from 'vuex'
import AddPersonToBusiness from '@/pages/App/People/dialogs/ViewUser/Businesses/AddPersonToBusiness'
import BusinessesList from '@/pages/App/People/dialogs/ViewUser/Businesses/BusinessesList'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { AddPersonToBusiness, BusinessesList, ComponentsFixedBar },
  computed: {
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    ...mapGetters(['businessModule'])
  },
  data () {
    return {
      isAddPersonToBusinessComponentVisible: false
    }
  },
  methods: {
    getUser () {
      this.$emit('getUser')
    },
    toggleAddPersonToBusinessComponent (value) {
      this.isAddPersonToBusinessComponentVisible = value
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String
    }
  }
}
</script>
